import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";
import {
  patchSpecimenRequest,
  getSpecimenRequest,
  Specimen,
} from "../../types";

export const specimenApi = createApi({
  reducerPath: "specimenApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Specimen"],
  endpoints: (builder) => ({
    getSpecimen: builder.query<Specimen, getSpecimenRequest>({
      query: ({ specimen_uuid }) => ({
        url: `/specimen/${specimen_uuid}`,
        method: "GET",
      }),
      providesTags: ["Specimen"],
      onQueryStarted: withErrorNotification("Failed to fetch specimen"),
    }),
    patchSpecimen: builder.mutation<Specimen, patchSpecimenRequest>({
      query: ({ specimen_uuid, data }) => ({
        url: `/specimen/${specimen_uuid}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["Specimen"],
      onQueryStarted: withErrorNotification("Failed to update specimen"),
    }),
  }),
});

export const { useGetSpecimenQuery, usePatchSpecimenMutation } = specimenApi;
